module.exports = __webpack_public_path__ + "img/00034.40989575.webp";